import React from 'react'
import { useLocation } from 'react-router-dom'
import { useProfile } from '../contexts/ProfileContext'
import { isAdminRoute, isEmployeeRoute, isFullWidthRoute } from '../lib/routes/publicRoutes'
import AppShell from './ui/AppShell'
import OfflineIndicator from './OfflineIndicator'
import type { ReactNode } from 'react'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const { profile } = useProfile()

  const currentIsAdminRoute  = isAdminRoute(location.pathname)
  // Portal/employee routes have their own PortalShell (sidebar + topbar).
  // Wrapping them in AppShell produces a duplicate admin header — skip it.
  const currentIsPortalRoute = isEmployeeRoute(location.pathname)

  const useAppShell = (currentIsAdminRoute || profile) && !currentIsPortalRoute
  const fullWidth = isFullWidthRoute(location.pathname)

  return (
    <>
      <OfflineIndicator />
      {useAppShell ? (
        <AppShell fullWidth={fullWidth}>
          {children}
        </AppShell>
      ) : (
        children
      )}
    </>
  )
}